import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Container = styled.div`
	position: relative;
	overflow-y: hidden;
	overflow-x: auto;
	width: 100%;

	-ms-overflow-style: none; /* Internet Explorer 10+ */
	scrollbar-width: none; /* Firefox */
	&::-webkit-scrollbar {
		/* Safari and Chrome */
		display: none;
	}
`;

export const Header = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	width: ${({ width }) => width}px;
`;

export const ContentHeader = styled.div`
	position: relative;
	height: 56px;
	display: flex;
`;

export const SubHeader = styled.div`
	position: relative;
	height: 32px;
	display: flex;
	align-items: center;
	border-bottom: 1px solid ${colors.grey3};
	border-right: 1px solid ${colors.grey3};
	border-collapse: collapse;
	background-color: ${colors.greyBg};
`;

export const PeriodHeader = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: space-evenly;
	height: 100%;
	padding-left: 24px;
	width: ${props => props.width}px;
	min-width: ${props => props.width}px;
	border-bottom: 1px solid ${colors.grey3};
	border-collapse: collapse;
	z-index: 1;
`;

export const PeriodHeaderTitle = styled.div`
	font-size: 16px;
	font-weight: 400;
	color: ${colors.black};
`;

export const PeriodHeaderValue = styled.div`
	font-size: 11px;
	font-weight: 400;
	color: ${colors.grey5};
`;

export const PeriodHeaderLine = styled.div`
	width: 1px;
	border: 1px solid ${colors.grey3};
	top: 0;
	right: 0;
	position: absolute;
	min-height: calc(100vh - 184px);
	height: ${props => props.height}px;
`;

export const PeriodColumn = styled.div`
	font-size: 11px;
	font-weight: 400;
	color: ${props => (props.highlight ? colors.grey7 : colors.grey4)};
	background-color: ${colors.greyBg};
	width: 70px;
	display: flex;
	justify-content: center;
	align-items: center;
	position: absolute;
	width: ${props => props.width}px;
	left: ${props => props.left}px;
	top: 8px;
`;

export const PeriodLine = styled.div`
	width: 1px;
	border: 1px dashed ${props => (props.highlight ? colors.grey4 : colors.grey3)};
	top: 24px;
	left: ${props => props.left}px;
	position: absolute;
	min-height: calc(100vh - 192px);
	height: calc(100vh - ${props => (200 + props.additionalHeight ? 16 : 0)}px);
	z-index: 2;
`;

export const PeriodHover = styled.div`
	position: absolute;
	top: 0;
	width: ${props => props.width}px;
	left: ${props => props.left}px;
	min-height: calc(100vh - 184px);
	height: ${props => props.height}px;
	background-color: ${colors.greyBg};
`;

export const TodayContainer = styled.div`
	position: absolute;
	top: 29px;
	left: ${props => props.left}px;
	z-index: 2;
`;

export const TodayTopCircle = styled.div`
	width: 5px;
	height: 5px;
	border-radius: 5px;
	background-color: ${colors.red1};
`;

export const TodayLine = styled.div`
	min-height: calc(100vh - 250px);
	height: ${props => props.height}px;
	background-color: ${colors.red1};
	width: 1px;
	margin: 0 auto;
`;

export const DraggableContainer = styled.div`
	position: relative;
	height: calc(100% - 88px);
	overflow-y: auto;
	overflow-x: hidden;
	width: ${({ width }) => width}px;

	-ms-overflow-style: none; /* Internet Explorer 10+ */
	scrollbar-width: none; /* Firefox */
	&::-webkit-scrollbar {
		/* Safari and Chrome */
		display: none;
	}
`;
